import { InfoIcon } from '@carboncopyco/icons';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import type { ReactNode } from 'react';

export const TimeLimitText = ({
  timeLimit,
  learnMore,
}: {
  timeLimit: string;
  learnMore: ReactNode;
}) => {
  return (
    <div className="flex items-center gap-1.5">
      <InfoIcon
        color={ColorHex.primary400}
        size={20}
      />
      <TextBase
        label={`You can add pages to this clone for the next ${timeLimit}.`}
        color="text-ds-natural-600"
      />
      {learnMore}
    </div>
  );
};
